<template>
    <div class="row no-padding" v-if="isFetchingData===false">

        <div class="col-xs-12 content-message" >

            <div class="alert alert-success lead-block text-center">
                <img :src="imagePath('icon-money-euro.png')" width="80px">
                <h3 class="text-center lead-title">{{'Receive 30€'|trans({currency:$currency.symbol(user.country)})}} </h3>
                <h4 class="text-center lead-title">{{'for each client sent to Belfix !'|trans}}</h4>
            </div>



            <p class="content-message message-spaced">
                {{'Do you have a request that you cannot meet ? too far ?too urgent ? not amongst your skills ?'|trans}}
                <br>
                <strong>{{'Send them to Belfix and get automatically 30€ !'|trans({currency:$currency.symbol(user.country)})}}</strong><br>
                {{'Just give us his phone number in the box below. It will be automatically recognized as the customer sent by you.'|trans}}
            </p>

            <div class=" row">

                <div class="col-xs-12" v-if="isSubmitted && !alreadyExists">
                    <div class="alert alert-success text-center" >
                        <strong>{{'Thank you for this recommendation! We will notify you if this client makes an appointment'|trans}}</strong>
                    </div>
                </div>

                <div class="col-xs-12" v-if="alreadyExists">
                    <div class="alert alert-danger text-center" >
                        <strong>{{'Already exists'|trans}}</strong>
                    </div>
                </div>

                <div class="col-xs-9">
                    <vue-phone-number-input v-model="phoneNumber"
                                            :translations="translations()"
                                            :preferred-countries="[ 'BE','FR','DE','ES','IT','NL']"
                                            :default-country-code="this.user.country"
                                            v-on:update="dataSelected"
                    >
                    </vue-phone-number-input>
                </div>

                <div class="col-xs-3 no-margin-bottom no-margin-top" v-if="!sendingData">
                    <button :disabled="!phoneNumberData.isValid" class="btn btn-primary full-width okay-btn" @click="submit">{{'OK'|trans}}</button>
                </div>

            </div>

            <template class="" v-if="leads.length>0">
                <hr>
                <h4 class="text-center">{{'My leads'|trans}}</h4>
                <table class="table table-striped">
                    <tbody>
                    <tr v-for="lead in leads">
                        <td>{{ lead.date_add|formatDate('D/MM/YYYY') }}</td>
                        <td>
                            <span v-if="isExpired(lead)">
                                {{'expired'|trans}}
                            </span>
                            <span v-else-if="lead.status===null">
                                {{'pending'|trans}}
                            </span>
                            <span v-else>
                                {{ lead.status|trans }}
                            </span>
                        </td>
                        <td>{{ lead.phone_number }}</td>
                    </tr>
                    </tbody>
                </table>
            </template>

        </div>
    </div>
</template>

<script>

    import moment from "moment-timezone";

	/** user phone number input **/
    // https://github.com/LouisMazel/vue-phone-number-input

	export default {
		components: {},
		props: {
			user: null
        },
        data() {
            return {
				isFetchingData: false,
				phoneNumber:null,
				isSubmitted:false,
                sendingData:false,
				phoneNumberData:{
					countryCallingCode : null,
					countryCode : null,
					phoneNumber:null,
					isValid:false
                },
                leads:[],
                alreadyExists:false
            }
        },
        created(){
            this.getLeads();
        },
        methods: {
			imagePath(imageName){
				return process.env.VUE_APP_API_BASE_URL_ASSETS + "/images/sources/"+imageName;
			},
            async submit(){
                this.sendingData = true;
				this.alreadyExists = false;
                const response = await this.$api.worker.sendLead(this.user.user_id, this.phoneNumberData);
                this.alreadyExists = response.lead_exits;
				this.sendingData = false;
				this.isSubmitted = true;
				await  this.getLeads();
            },
			async getLeads(){
				this.leads = await this.$api.worker.getLeads();
			},
            translate(value){
				return window.translations[value];
            },
			translations(){
				return {
					countrySelectorLabel: this.translate('Country code'),
					countrySelectorError: this.translate('Choose a country'),
					phoneNumberLabel: this.translate('Phone Number'),
					example: this.translate('Example :')
				};
			},
            dataSelected(value){
				this.phoneNumberData = value;
            },
			isExpired(lead) {
                let date = moment(lead.date_add);
                let today = moment();
				let countDays = today.diff(date, 'days');
                if(lead.status === null && countDays > 10){
                    return true;
                }
                return false;
			}
        },
        computed: {

        },
        watch:{

        },
        filters:{
			formatDate(value, format) {
				if (value) {
					if (format === undefined) {
						format = 'YYYY-MM-DD HH:mm';
					}
					return moment(String(value)).format(format)
				}
			}
        }
    }

</script>

<style scoped>
    .lead-block{
        padding:20px;
    }
    .lead-block > .h1, .h2, .h3, h1, h2, h3{
        margin-top:0;
        margin-bottom: 0;
    }

    .lead-title{
        color: white;
        line-height: 30px;
    }

    .content-message{
        background-color: white;
        padding:10px;
    }

    .message-spaced{
        line-height: 20px;
    }

    .okay-btn{
        border-radius: 4px;
        padding:9px;
        margin: 0;
    }

</style>
